module.exports = __webpack_public_path__ + "images/one-year-club-eb4c9835b4208e3478e2094f5022166d.png";